import { render, staticRenderFns } from "./CreateNewQuestionPackageDialog.vue?vue&type=template&id=a61e0972"
import script from "./CreateNewQuestionPackageDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewQuestionPackageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports